module.exports = __webpack_public_path__ + "producr-dried fresh-grass-19.jpg?2f3949c1d5b5553cbdb5a9415e2528ec";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-19.jpg
// module id = 77
// module chunks = 0